import { Flex } from "@chakra-ui/react";
import { ContactForm } from "../components/ContactForm";
import { Header } from "../components/Header";

function SaveContact() {
  return (
    <>
      <Header />
      <Flex
        h="100vh"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        m={5}
      >
        <ContactForm />
      </Flex>
    </>
  );
}

export default SaveContact;
